<template>
	<div>
	<loader v-if="loader" color="white"></loader>
		<div class="container">
			<div class="row">
				<div class="col-12 biz-title-container">
					<div class="container">
						<div class="biz-panel-title">
							<h3>Usluge</h3>
							<a href="#" data-toggle="modal" data-target="#addServModal" class="btn fs-btn dark-border small"><span class="fas fa-plus fa-fw"></span></a>
						</div>
					</div>
					<div class="col-12">
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12 salon-container mb-3">
					<div class="container mb-3">
						<div class="row no-gutters">
							<div class="col-12 mt-3">
								<notify></notify>
							</div>
							<div class="col-12">
								<table id="table-frizure" class="table table-sm">
									<tbody v-if="user.salon != null">
										<tr v-for="(serv,index) in user.salon.services" :key="index">
											<td class="text-left">
												<p>{{serv.name}}<span v-if="serv.action" class="badge badge-danger adm-akcija">AKCIJA!</span><span v-if="serv.featured" class="badge badge-success adm-serv-feat">Istaknuto!</span></p>
												<small>{{serv.description}}</small>
											</td>
											<td class="text-right td-flex">
												<div class="td-2 mr-3">
													<p>{{Number(serv.price) ? Number(serv.price):'invalid price'}} kn</p>
													<small>{{serv.time}} min</small>
												</div>
												<div class="td-1">
													<a href="#" @click="editService=serv" data-toggle="modal" data-target="#editServModal" class="btn fs-btn dark small mr-1"><span class="far fa-edit"></span></a>
													<a href="#" @click="deleteItem(serv.id)" data-toggle="modal" data-target="" class="btn fs-btn danger-border small"><span class="far fa-trash-alt"></span></a>
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal animated fadeIn" id="addServModal" tabindex="-1" role="dialog" aria-labelledby="bookModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header text-center">
						<h4 class="modal-title w-100 font-weight-bold">Dodaj uslugu</h4>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body mx-3">
						<form id="">
							<div class="row">
								<div class="col-12 mb-3">
									<input id="name" type="text" v-model="service.name" class="form-control" placeholder="Ime usluge" required>
								</div>
								<div class="col-12 col-sm-6 mb-3">
									<div class="input-group">
										<input id="contact" type="text" v-model="service.price" class="form-control" placeholder="Cijena" required>
										<div class="input-group-append">
											<span class="input-group-text">HRK</span>
										</div>
									</div>
								</div>
								<div class="col-12 col-sm-6 mb-3">
									<div class="input-group">
										<input id="place" type="number" v-model="service.time" class="form-control" placeholder="Trajanje" required>
										<div class="input-group-append">
											<span class="input-group-text">min</span>
										</div>
									</div>
								</div>
								<div class="col-12 mb-3">
									<textarea v-model="service.description" maxlength="40" class="form-control" id="servArea" rows="2" placeholder="kratki opis usluge" required></textarea>
								</div>
								<div class="col-12 mb-3 text-center">
									<div class="form-check form-check-inline">
										<input class="form-check-input" type="checkbox" id="inlineCheckbox13" v-model="service.featured">
										<label class="form-check-label" for="inlineCheckbox13">Istaknuto</label>
									</div>
									<div class="form-check form-check-inline">
										<input class="form-check-input" type="checkbox" id="inlineCheckbox2" v-model="service.action">
										<label class="form-check-label" for="inlineCheckbox2">Akcija</label>
									</div>
								</div>
								<div class="col-12">
									<notify></notify>
								</div>
							</div>
							<button @click="save()" id="submit" type="button" class="fs-btn dark text-uppercase btn-lg btn-block">
								<span>Dodaj</span>
							</button>
						</form>
					</div>
					<div id="book-modal-footer" class="modal-footer">
					</div>
				</div>
			</div>
		</div>

		<div class="modal animated fadeIn" id="editServModal" tabindex="-1" role="dialog" aria-labelledby="bookModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header text-center">
						<h4 class="modal-title w-100 font-weight-bold">Ažuriraj uslugu</h4>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body mx-3">
						<form id="" action="" method="post">
							<div class="row">
								<div class="col-12 mb-3">
									<input id="servName" v-model="editService.name" type="text" class="form-control" placeholder="Usluga" aria-label="usluga" aria-describedby="usluga" required disabled>
								</div>
								<div class="col-12 col-sm-6 mb-3">
									<div class="input-group">
										<input id="servPrice" v-model="editService.price" type="text" class="form-control" placeholder="Cijena" aria-label="cijena usluge" aria-describedby="cijena usluge" required>
										<div class="input-group-append">
											<span class="input-group-text">HRK</span>
										</div>
									</div>
								</div>
								<div class="col-12 col-sm-6 mb-3">
									<div class="input-group">
										<input id="servTime" v-model="editService.time" type="number" class="form-control" placeholder="Vrijeme (min)" aria-label="vrijeme trajanja" aria-describedby="vrijeme trajanja" required>
										<div class="input-group-append">
											<span class="input-group-text">min</span>
										</div>
									</div>
								</div>
								<div class="col-12 mb-3">
									<textarea class="form-control" v-model="editService.description" id="servArea" rows="2" maxlength="40" placeholder="kratki opis usluge" aria-label="opis usluge" aria-describedby="opis usluge" required></textarea>
								</div>
								<div class="col-12 mb-3 text-center">
									<div class="form-check form-check-inline">
										<label class="form-check-label" for="inlineCheckbox4">
											<input class="form-check-input" v-model="editService.featured" type="checkbox" id="inlineCheckbox4">
											Istaknuto
										</label>
									</div>
									<div class="form-check form-check-inline">
										<input class="form-check-input" v-model="editService.action" type="checkbox" id="inlineCheckbox3">
										<label class="form-check-label" for="inlineCheckbox3">Akcija</label>
									</div>
								</div>
							</div>
							<notify></notify>
							<button @click="updateService()" data-dismiss="modal" id="submit" type="button" class="fs-btn dark text-uppercase btn-lg btn-block">
								<span>Spremi promjene</span>
							</button>
						</form>
					</div>
					<div id="book-modal-footer" class="modal-footer">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex';
	export default {
		name: 'service',
		computed: {
			...mapState({
				user: (state) => state.user,
				loader: (state) => state.loader,
				endpoint: (state) => state.endpoint,
				token: (state) => state.token,
			})
		},
		data() {
			return {
				service: {
					name: '',
					time: '',
					price: '',
					description: '',
					featured: false,
					action: false
				},
				editService: {}
			}
		},
		methods: {
			save() {
				if (this.user.salon == null) {
					this.$store.commit('setNotification', {
						type: 2,
						msg: 'Potrebno je prvo ažurirati salon.'
					})
					return false;
				}

				if (this.service.name.length == 0 || this.service.time.length == 0 || this.service.price.length == 0) {
					this.$store.commit('setNotification', {
						type: 2,
						msg: 'Molimo vas ispunite sva potrebna polja.'
					})
					return false;
				}

				this.$store.state.loader = true;
				this.service.salon = this.user.salon.id;
				this.$store.dispatch('post', {
						details: this.service,
						endpoint: this.endpoint + 'add-service?token=' + this.token
					})
					.then((data) => {
						console.log(data);
						if (data.data.status) {
							this.$store.state.user.salon.services.push(data.data.data);
							this.$store.commit('setUser', {
								user: this.$store.state.user,
								token: this.$store.state.token
							});
							this.service = {
								name: '',
								time: '',
								price: '',
								description: '',
								featured: false,
								action: false
							};
							this.$store.commit('setNotification', {
								type: 1,
								msg: data.data.message
							});
						}
						this.$store.state.loader = false;
					})
					.catch((error) => {
						console.log(error);
						this.$store.dispatch("handleError", error);
						this.$store.state.loader = false;
					})
			},
			deleteItem(id) {
				if (!confirm("Jeste li sigurni da želite izbrisati ovu uslugu?")) {
					return false;
				}
				this.$store.state.user.salon.services = this.$store.state.user.salon.services.filter((d) => d.id != id);

				this.$store.dispatch('get', this.endpoint + 'delete-service/' + id + '?token=' + this.token)
					.then((data) => {
						console.log(data);
						if (data.data.status) {
							this.$store.commit('setUser', {
								user: this.$store.state.user,
								token: this.$store.state.token
							});
							this.$store.commit('setNotification', {
								type: 1,
								msg: data.data.message
							});
						}
					})
					.catch((error) => {
						console.log(error.request);
						this.$store.dispatch("handleError", error);
					})
			},
			updateService() {

				var editService = this.editService;
				if (this.editService.name.length == 0 || this.editService.time.length == 0 || this.editService.price.length == 0) {
					this.$store.commit('setNotification', {
						type: 2,
						msg: 'Molimo Vas iapunite sva obavezna polja.'
					})
					return false;
				}

				this.$store.state.loader = true;

				this.$store.dispatch('post', {
						details: editService,
						endpoint: this.endpoint + 'update-service/' + editService.id + '?token=' + this.token
					})
					.then((data) => {
						console.log(data);
						if (data.data.status) {
							this.$store.state.user.salon.services = this.$store.state.user.salon.services.map((d) => {
								if (d.id == editService.id) {
									return data.data.data;
								}
								return d;
							});
							this.$store.commit('setUser', {
								user: this.$store.state.user,
								token: this.$store.state.token
							});
							this.$store.commit('setNotification', {
								type: 1,
								msg: data.data.message
							});
						}
						this.$store.state.loader = false;
					})
					.catch((error) => {
						console.log(error.request);
						this.$store.dispatch("handleError", error);
						this.$store.state.loader = false;
					})
			},
			checkFeatured(e) {
				e.preventDefault();

				if (this.user.salon.services.filter((d) => d.featured).length < 10) {
					this.service.featured = !this.service.featured;
				} else {
					this.service.featured = false;
					this.$store.commit('setNotification', {
						type: 2,
						msg: 'Dosegli ste maksimalni broj (10) usluga koje možete istaknuti.'
					});
				}
			},
			checkFeatured2(e) {
				e.preventDefault();
				if (this.user.salon.services.filter((d) => d.featured).length < 10) {
					this.editService.featured = !this.editService.featured;
				} else {
					this.editService.featured = false;
					this.$store.commit('setNotification', {
						type: 2,
						msg: 'Dosegli ste maksimalni broj (10) usluga koje možete istaknuti.'
					});
				}
			}
		},
		created() {
			// console.log(Number('fdfd'));
		}
	}

</script>
